module.exports = __webpack_public_path__ + "img/tnav_discord_black.84d4db48.png";